import { IIssueApi } from "@schemas/issueSchema";
import { Stack } from "@mantine/core";
import React from "react";
import { selectCurrentProjectId } from "../../../../../global/globalSliceCommon";
import { useAppSelector } from "../../../../../hooks";
import { selectHttpIssueBoard } from "../../redux/selectors/issueRtkSelectors";
import ConnectedTasksAndIssuesMiniTable from "../MiniTables/ConnectedTasksAndIssuesMiniTable";
import ConnectedTasksIssueboardTable from "./ConnectedTasksIssueboardTable";

const IssueTableDetailCellRenderer: React.FC<{
  data: IIssueApi;
}> = ({ data }) => {
  const projectId = useAppSelector(selectCurrentProjectId);
  const issueBoard = useAppSelector(selectHttpIssueBoard);

  return (
    <Stack gap="xs" p="xs">
      <ConnectedTasksIssueboardTable issueId={data._id} />
      {projectId != null && issueBoard != null && data.connectedTasksAndIssuesFromOtherBoards?.length > 0 && (
        <ConnectedTasksAndIssuesMiniTable
          fullWidth
          issue={data}
          issueId={data._id}
          issueBoardId={issueBoard._id}
          projectId={projectId}
          issueBoard={issueBoard}
        />
      )}
    </Stack>
  );
};

export default IssueTableDetailCellRenderer;
